// TODO(backend/documents): Document storage is post-MVP. No backend schema exists yet.
// Keeping design + mock data intact so it can be wired when the documents subgraph is ready.
// When ready: add DocumentsList($expeditionId) query, wire to this tab, remove DocumentEntry mock.

import { Button } from "@bowfast/ui/components/button";
import { Card, CardContent, CardHeader, CardTitle } from "@bowfast/ui/components/card";
import { motion } from "framer-motion";
import { FileTextIcon, PlusIcon } from "lucide-react";
import { fadeUp, stagger } from "~/lib/animations";
import type { DocumentEntry } from "~/pages/expeditions/expedition-detail.mock";

export function DocumentsTab({ documents }: Readonly<{ documents: DocumentEntry[] }>) {
  return (
    <motion.div initial="initial" animate="animate" variants={stagger} className="space-y-5">
      <motion.div variants={fadeUp}>
        <Card>
          <CardHeader>
            <div className="flex items-center justify-between">
              <CardTitle className="flex items-center gap-2 text-sm font-semibold">
                <FileTextIcon className="size-4 text-abyss-500" />
                Documents
                <span className="ml-1 rounded-full bg-muted px-2 py-0.5 text-[0.625rem] font-bold text-muted-foreground">
                  {documents.length}
                </span>
              </CardTitle>
              <Button size="sm" variant="outline" className="gap-1.5">
                <PlusIcon className="size-3.5" />
                Upload
              </Button>
            </div>
          </CardHeader>
          <CardContent className="space-y-2 p-4 pt-0">
            {documents.map((doc) => (
              <div
                key={doc.id}
                className="flex items-center justify-between rounded-lg border border-border bg-card px-4 py-3"
              >
                <div className="flex items-center gap-3">
                  <div className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-abyss-50 dark:bg-abyss-900">
                    <FileTextIcon className="size-4 text-abyss-500" />
                  </div>
                  <div>
                    <p className="text-sm font-medium">{doc.name}</p>
                    <p className="text-xs text-muted-foreground">
                      {doc.type} · Uploaded {doc.uploadedLabel}
                    </p>
                  </div>
                </div>
                <Button size="sm" variant="ghost" className="text-muted-foreground">
                  Download
                </Button>
              </div>
            ))}
          </CardContent>
        </Card>
      </motion.div>
    </motion.div>
  );
}
